import React from 'react';
import BrokerageContinuum from '../BrokerageContinuum';
import Error404 from "../Error404";
import ChapterPage from "../ChapterPage";
import ChapterContentSwitch from "../ChapterContentSwitch/ChapterContentSwitch";

export default (props) => {
    switch(props.params.slug) {
        case 'brokerage-continuum':
            return <BrokerageContinuum {...props}/>;
        case 'strive-pillars':
        case 'administration':
        case 'tips-of-the-trade-and-inspiration':
        case 'events':
        case 'roles-and-responsibilities':
            return <ChapterPage {...props}/>;
        case 'business-planning':
            // Content page that can grow sub-tiles: decide content vs tile view dynamically.
            return <ChapterContentSwitch {...props}/>;
        default:
            return <Error404/>;
    }
}